export const StubProjectsPageTexts = {
  thisPage: 'Ця сторінка',
  will: 'буде',
  be: 'готова',
  readySoon: 'найближчим часом',
};
